import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  Badge,
  Breadcrumb,
  Button,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Table,
  Tooltip,
  message,
} from "antd";
import {
  CloseCircleFilled,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  SearchOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import DatePicker from "react-modern-calendar-datepicker";
import moment from "moment-jalaali";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import BarcodeReportForm from "../forms/BarcodeReport";


class BarcodeReport extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      filter: [],
      productBarcodes: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},
      barcodeType: "",
      deleted_barcodes: [],
      orderView: false,
      showBarcodes: false,
    };


    this.formRef = React.createRef();
    this.productBarcodeRef = React.createRef();
    this.timeout =  0;
  }

  fetch = (params = {}) => {
    const {
      filterEndDate,
      filterOrderType,
      filterStatus,
      filterPayStatus,
      filterPayType,
      filterSearch,
      filterStartDate,
      filterSearchUser
    } = this.state;

    params.q = filterSearch;
    params.filterSearchUser = filterSearchUser;
    params.endDate = filterEndDate
      ? moment(
          `${filterEndDate.year}-${filterEndDate.month}-${filterEndDate.day}`,
          Constants.jDateFormat
        ).format(Constants.dateFormat)
      : null;
    params.startDate = filterStartDate
      ? moment(
          `${filterStartDate.year}-${filterStartDate.month}-${filterStartDate.day}`,
          Constants.jDateFormat
        ).format(Constants.dateFormat)
      : null;
    // params.orderType = filterOrderType;
    params.newList = true;
    params.barcodeType = this.state.barcodeType;


    this.setState({ loading: true });

    API.BarcodeReports
      .list(params)
      .then((result) => {
        console.log("BarcodeReports", result)
        if (result.data) {

          this.setState({
            loading: false,
            data: result.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.current_page,
                pageSize: result.per_page,
                total: result.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };



  showView = async (product = {}) => {
    let params = {}
    const {
      filterEndDate,
      filterOrderType,
      filterStatus,
      filterPayStatus,
      filterPayType,
      filterSearch,
      filterStartDate,
      filterSearchUser
    } = this.state;

    params.q = filterSearch;
    params.filterSearchUser = filterSearchUser;
    params.endDate = filterEndDate
        ? moment(
            `${filterEndDate.year}-${filterEndDate.month}-${filterEndDate.day}`,
            Constants.jDateFormat
        ).format(Constants.dateFormat)
        : null;
    params.startDate = filterStartDate
        ? moment(
            `${filterStartDate.year}-${filterStartDate.month}-${filterStartDate.day}`,
            Constants.jDateFormat
        ).format(Constants.dateFormat)
        : null;
    // params.orderType = filterOrderType;
    params.newList = true;
    params.barcodeType = this.state.barcodeType;
    // let barcodes  = await this.getProductBarcodes(order)
    // console.log("showView")
    this.setState({ showBarcodes: true, selected: product });
    setTimeout(() => {
      this.productBarcodeRef.current.handleDidMount(product, params);
    }, 0);
  };

  hideView = () => {
    this.setState({ showBarcodes: false });
    // setTimeout(() => {
    //   this.productBarcodeRef.current.handleWillUnmount();
    // }, 0);
  };

  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      //search function
      this.fetch({ page: this.state.pagination.current });
    }, 500);
    // setTimeout(() => {
    //   this.fetch({ page: this.state.pagination.current });
    // }, 500);
  };

  handleDelete = (id) => {
    Modal.confirm({
      title: Resources.confirmDeleteOffer,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.BarcodeReports
          .delete(id)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    this.setState({ submitting: true });

    API.order
      .update(values, this.state.selected.id)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideEdit();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleTableChange = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    console.log("fetch barcodes")
      this.fetch({ page: 1 });
  }


  handleSelectBarcodeType = (value) => {
    this.setState({barcodeType:value})
    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  };

  render() {
    const {
      data,
      filterEndDate,
      filterStartDate,
      loading,
      orderEdit,
      showBarcodes,
      pagination,
      selected,
      submitting,
      printView,
      deleted_barcodes,
      productBarcodes
    } = this.state;
    const { permissions } = this.props;

    const top_columns = [
      {
        title: Resources.title,
        dataIndex: "name",
        // width: "30px",
      },
      {
        title: Resources.barcode,
        dataIndex: "code",
        // width: "30px",
      },
      {
        render: (val, record) => (
            <Fragment>
            <Tooltip title={Resources.show}>
              <Button
                  type="link"
                  icon={<EyeOutlined />}
                  onClick={() => this.showView(record)}
              />
            </Tooltip>
            </Fragment>
        )
      }

    ];
    const columns = [
      {
        title: Resources.barcode,
        dataIndex: "barcode",
        width: "30px",
      },
      {
        title: Resources.registrar,
        dataIndex: "user",
        width: "30px",
      },
      {
        title: Resources.buyer,
        dataIndex: "buyer",
        width: "30px",
      },
      {
        title: Resources.buyer_mobile,
        dataIndex: "buyer_mobile",
        width: "30px",
      },


      {
        title: Resources.count,
        dataIndex: "count",
        width: "30px",
      },

      {
        title: Resources.row,
        dataIndex: "row",
        width: "30px",
      },
      {
        title: Resources.identifier,
        dataIndex: "identifier",
        width: "30px",
      },
      {
        title: Resources.shelf,
        dataIndex: "shelf",
        width: "30px",
      },
      {
        title: Resources.dateAndTime,
        dataIndex: "created_at",
        width: "30px",
        render: (val) => moment(val).format(Constants.jDateTimeFormat),
      },
      {
        title: Resources.type,
        dataIndex: "is_scan",
        width: "30px",
        render: (val) => (val == "1") ? <span style={{color:"blue"}}  >{Resources.scanned}</span>:  <span style={{color:"red"}}  >{Resources.deleted}</span>,
      },

    ];

    if (permissions.action || permissions.view) {
      columns.push({
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            {permissions.action && (
              <Tooltip title={Resources.delete}>
                <Button
                  type="link"
                  icon={<DeleteOutlined />}
                  onClick={() => this.handleDelete(val)}
                />
              </Tooltip>
            )}
          </Fragment>
        ),
      });
    }

    const DatePickerInput = ({ ref }, date, placeholder) => (
      <Input
        value={date ? `${date.year}-${date.month}-${date.day}` : date}
        placeholder={placeholder}
        ref={ref}
        readOnly
      />
    );

    return (
      <Fragment>

        <BarcodeReportForm
          ref={this.productBarcodeRef}
          onCancel={this.hideView}
          onSubmit={this.hideView}
          submitting={submitting}
          visible={showBarcodes}
          productBarcodes={productBarcodes}

        />
        <Breadcrumb>
          <Breadcrumb.Item> {Resources.barcode_reports} </Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Row gutter={24} style={{ marginBottom: 16 }}>
            <Col xs={24} md={4}>
              <DatePicker
                locale="fa"
                value={filterStartDate}
                onChange={(value) =>
                  this.handleFilter(value, "filterStartDate")
                }
                renderInput={(ref) =>
                  DatePickerInput(ref, filterStartDate, Resources.fromDate)
                }
                shouldHighlightWeekends
              />
              {filterStartDate && (
                <CloseCircleFilled
                  className="ant-input-clear-icon ant-input-clear-icon-external"
                  onClick={() => this.handleFilter(null, "filterStartDate")}
                />
              )}
            </Col>


            <Col xs={24} md={4}>
              <DatePicker
                locale="fa"
                value={filterEndDate}
                onChange={(value) => this.handleFilter(value, "filterEndDate")}
                renderInput={(ref) =>
                  DatePickerInput(ref, filterEndDate, Resources.toDate)
                }
                shouldHighlightWeekends

              />
              {filterEndDate && (
                <CloseCircleFilled
                  className="ant-input-clear-icon ant-input-clear-icon-external"
                  onClick={() => this.handleFilter(null, "filterEndDate")}
                />
              )}
            </Col>

            <Col xs={24} md={4}>
              <Select
                  filterOption
                  onChange={(value) => this.handleSelectBarcodeType(value)}
                  optionFilterProp="name"
                  style={{ display: "block" }}
                  placeholder={Resources.barcodesType}

                  showSearch
                  allowClear
              >
                <Select.Option value="all" >{Resources.all}</Select.Option>
                <Select.Option value="scan" >{Resources.scanned}</Select.Option>
                <Select.Option value="delete" >{Resources.deleted}</Select.Option>
              </Select>
            </Col>
            <Col xs={24} md={8}>
              <Tooltip title={Resources.productNameOrBarcode}>
                <Input
                  type="text"
                  prefix={<SearchOutlined />}
                  placeholder={Resources.productNameOrBarcode}
                  // defaultValue={this.props.match.params.phone}
                  onChange={({ target: { value } }) =>
                    this.handleFilter(value, "filterSearch")
                  }
                  allowClear
                />
              </Tooltip>
            </Col>
            {/*<Col xs={24} md={5}>*/}
            {/*  <Tooltip title={Resources.userNameOrMobile}>*/}
            {/*    <Input*/}
            {/*      type="text"*/}
            {/*      prefix={<SearchOutlined />}*/}
            {/*      placeholder={Resources.userNameOrMobile}*/}
            {/*      // defaultValue={this.props.match.params.phone}*/}
            {/*      onChange={({ target: { value } }) =>*/}
            {/*        this.handleFilter(value, "filterSearchUser")*/}
            {/*      }*/}
            {/*      allowClear*/}
            {/*    />*/}
            {/*  </Tooltip>*/}
            {/*</Col>*/}
          </Row>

        </div>
        <div className="ant-content">
          <Table
            columns={top_columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}

            // expandable={{
            //   expandedRowRender: (record) => (
            //       <Table
            //           columns={columns}
            //           dataSource={record.deleted_barcodes}
            //           pagination={false}
            //           rowKey="id"
            //       />
            //   ),
            //   rowExpandable: (record) => true,
            // }}

            size="small"
            rowKey="id"
            scroll={{ x: 1000 }}
          />
          {!!pagination.total && (
            <PaginationInfo
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
            />
          )}
        </div>
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.cart_option),
        view: CheckPermission(state.app.user, Permissions.cart_view),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(BarcodeReport);
